import { render, staticRenderFns } from "./warehouse-history-price-editor.vue?vue&type=template&id=755b51e6"
import script from "./warehouse-history-price-editor.vue?vue&type=script&lang=js"
export * from "./warehouse-history-price-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports